'use client';
import React from 'react';
import { useRouter } from 'next/navigation';
import { DESTINATIONS } from '../data/destinations';

const DEST_TO_HOTEL: Record<string, string> = {
  'dest-algiers': 'prop-1',
  'dest-oran': 'prop-2',
  'dest-constantine': 'prop-3',
  'dest-sahara': 'prop-4',
};

const DEST_TO_CITY: Record<string, string> = {
  'dest-algiers': 'Algiers',
  'dest-oran': 'Oran',
  'dest-constantine': 'Constantine',
  'dest-sahara': 'Tamanrasset',
};

export default function DestinationsGrid() {
  const router = useRouter();

  const handleDestClick = (destId: string, destName: string) => {
    const city = DEST_TO_CITY[destId] ?? destName;
    router.push(`/hotels?city=${encodeURIComponent(city)}`);
  };

  return (
    <section className="py-10 sm:py-14" style={{ background: '#FBF8F3' }}>
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10">
        <div className="mb-6 sm:mb-8">
          <p className="text-xs font-display font-600 text-accent-500 uppercase tracking-widest mb-1">
            Explore Algeria
          </p>
          <h2 className="font-display text-2xl sm:text-3xl font-800 text-gray-900" style={{ fontWeight: 800 }}>
            Popular Destinations
          </h2>
        </div>

        {/* Mobile: 2-col equal grid, Desktop: bento */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3 lg:gap-4 auto-rows-[130px] sm:auto-rows-[180px]">
          {DESTINATIONS?.map((dest) => (
            <div
              key={dest?.id}
              onClick={() => handleDestClick(dest?.id, dest?.name)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && handleDestClick(dest?.id, dest?.name)}
              aria-label={`Explore ${dest?.name} — ${dest?.properties} properties`}
              className={`group relative rounded-2xl overflow-hidden cursor-pointer active:scale-[0.98] transition-transform duration-150 ${dest?.span ?? ''}`}
              style={{ minHeight: 130 }}>
              <img
                src={dest?.image}
                alt={dest?.alt}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/10 to-transparent" />
              {/* Hover overlay */}
              <div className="absolute inset-0 bg-primary-500/0 group-hover:bg-primary-500/10 transition-all duration-300" />
              <div className="absolute bottom-0 left-0 p-2.5 sm:p-4">
                <h3 className="font-display font-700 text-white text-sm sm:text-lg leading-tight" style={{ fontWeight: 700 }}>
                  {dest?.name}
                </h3>
                <p className="text-white/75 text-xs font-body hidden sm:block">{dest?.subtitle}</p>
                <span className="inline-block mt-1 px-2 py-0.5 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-body border border-white/20">
                  {dest?.properties} properties
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}